const news_data = [
  {
    id: "Kavana introduces digital equb platform named Debo",
    text: "Kavana Technologies PLC introduces a digital equb platform named Debo ..",
    title: "Kavana introduces digital equb platform named Debo",
    image: "/images/blog/DeboCover.png",
    date: "5 Feb",
    time: "3 min read",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.debo",
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "Meet our classified listing platform",
    text: "Our classified listing platform dubbed 'eBuy' connects buyers and sellers in Ethiopia with ease...",
    title: "Meet our classified listing platform: eBuy",
    image: "/images/blog/ebuy.webp",
    date: "5 Feb",
    time: "3 min read",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "Viva Sounds: a digital gospel songs streaming platform",
    text: "You can now stream/download gospel songs in our platform: Viva Sounds ...",
    title: "Viva Sounds: a digital gospel music streaming platform",
    image: "/images/blog/VivaSoundsCover.png",
    date: "22 Feb",
    time: "3 min read",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.viva_sounds",
    authorImage: "/images/blog/VivaSoundsCover.png",
    authorName: "Admin",
  },
  {
    id: "Hulu Tender: subscription based tender follow-up platform",
    text: "Kavana developed a subscription based tender follow-up platform...",
    title: "Hulu Tender: subscription based tender follow-up platform",
    image: "/images/blog/HuluTenderCover.png",
    date: "18 Jan",
    time: "3 min read",
    href: "https://play.google.com/store/apps/details?id=com.kavanatech.HuluTender",
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  //   {
  //     id: "3Incredible Amount of Developer Energy' in Web3",
  //     text: "Since we launched Tezos at the end of 2021, many awesome creators...",
  //     title: "Incredible Amount of Developer Energy' in Web3",
  //     image: "/images/blog/HuluTenderCover.png",
  //     date: "15 Jan",
  //     time: "3 min read",
  //     href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  //   },
  //   {
  //     id: "4Inflation is up, it matters: High prices plague Biden's",
  //     text: "Since we launched Tezos at the end of 2021, many awesome creators...",
  //     title: "Inflation is up, it matters: High prices plague Biden's",
  //     image: "/images/blog/HuluTenderCover.png",
  //     date: "23 Dec",
  //     time: "3 min read",
  //     href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  //   },
  //   {
  //     id: "6Mint your own Tezos collections",
  //     text: "Since we launched Tezos at the end of 2021, many awesome creators...",
  //     title: "Mint your own Tezos collections",
  //     image: "/images/blog/HuluTenderCover.png",
  //     date: "5 Feb",
  //     time: "3 min read",
  //     href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  //   },
  //   {
  //     id: "7Mint your own Tezos collections",
  //     text: "Since we launched Tezos at the end of 2021, many awesome creators...",
  //     title: "Mint your own Tezos collections",
  //     image: "/images/blog/HuluTenderCover.png",
  //     date: "5 Feb",
  //     time: "3 min read",
  //     href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  //   },
  //   {
  //     id: "8List your collection for secondary sales",
  //     text: "Since we launched Tezos at the end of 2021, many awesome creators...",
  //     title: "List your collection for secondary sales",
  //     image: "/images/blog/HuluTenderCover.png",
  //     date: "22 Feb",
  //     time: "3 min read",
  //     href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  //   },
  //   {
  //     id: "9The biggest moves in NFTs, Bitcoin, crypto rules",
  //     text: "Since we launched Tezos at the end of 2021, many awesome creators...",
  //     title: "The biggest moves in NFTs, Bitcoin, crypto rules",
  //     image: "/images/blog/HuluTenderCover.png",
  //     date: "18 Jan",
  //     time: "3 min read",
  //     href: "https://play.google.com/store/apps/details?id=com.kavanatech.ebuy",
  //   },
];

const single_news_data = [
  {
    id: "post_1",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "Mint your own Tezos collections",
    image: "/images/blog/post_1.jpg",
    date: "5 Feb",
    time: "3 min read",
    subImages: ["/images/blog/gallery_1.jpg", "/images/blog/gallery_2.jpg"],
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "post_2",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "Mint your own Tezos collections",
    image: "/images/blog/post_2.jpg",
    date: "5 Feb",
    time: "3 min read",
    subImages: ["/images/blog/gallery_1.jpg", "/images/blog/gallery_2.jpg"],
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "post_3",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "Kavana Launched a tender platform for businesses",
    image: "/images/blog/post_3.jpg",
    date: "22 Feb",
    time: "3 min read",
    subImages: ["/images/blog/gallery_1.jpg", "/images/blog/gallery_2.jpg"],
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "post_4",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "The biggest moves in NFTs, Bitcoin, crypto rules",
    image: "/images/blog/post_4.jpg",
    date: "18 Jan",
    time: "3 min read",
    subImages: ["/images/blog/gallery_1.jpg", "/images/blog/gallery_2.jpg"],
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "post_5",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "Incredible Amount of Developer Energy' in Web3",
    image: "/images/blog/post_5.jpg",
    date: "15 Jan",
    time: "3 min read",
    subImages: ["/images/blog/gallery_1.jpg", "/images/blog/gallery_2.jpg"],
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
  {
    id: "post_6",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "Inflation is up, it matters: High prices plague Biden's",
    image: "/images/blog/post_6.jpg",
    date: "23 Dec",
    time: "3 min read",
    subImages: ["/images/blog/gallery_1.jpg", "/images/blog/gallery_2.jpg"],
    authorImage: "/images/blog/author_large.jpg",
    authorName: "Admin",
  },
];

export { news_data, single_news_data };
